import React from 'react';
import { classNameTriskeleParser } from '../utilities/customStyles';
import Icon from './Icon';

const PermissionsCard = (props) => {
  const {
    selectPermission, selectedPermission, rowIndex, permissions
  } = props;

  const renderText = (permissionId) => {
    switch (permissionId) {
      case 1:
        return 'Makes visible all lifestyle data accessible to Prism from the Client\'s Health app';
      case 2:
        return 'Makes visible all medical data accessible to Prism from every Provider.';
      case 3:
        return 'Allows you to see the Client\'s other Providers\' names and profiles.';
      default:
        return '';
    }
  };

  return (
    <div className="row-flex column-gap-8 justify-center">
      {permissions.map((permission, permissionIndex) => (
        <div style={{ position: 'relative' }} key={permission.VisualName + "_" + permissionIndex + "_" + rowIndex}>
          <div
            onMouseEnter={() => selectPermission(rowIndex, permissionIndex)}
            onMouseLeave={() => selectPermission(null)}
          >
            <Icon
              classNames={`permission-icon-size permission_icon ${classNameTriskeleParser(
                permission.VisualName,
                permission.VisualType,
                'Icon'
              )}`}
            />
          </div>
          {selectedPermission
            && selectedPermission.permissionIndex === permissionIndex
            && selectedPermission.rowIndex === rowIndex && (
              <div
                className="dialog_items position-left-100"
              >
                <label style={{ marginBottom: 0 }}>
                  {renderText(permission.Permissionid)}
                </label>
              </div>
          )}
        </div>
      ))}
    </div>
  );
};

export const PermissionsCardMobile = (props) => {
  const {
    selectPermission, selectedPermission, rowIndex, permissions
  } = props;

  const renderText = (permissionId) => {
    switch (permissionId) {
      case 1:
        return 'Makes visible all lifestyle data accessible to Prism from the Client\'s Health app';
      case 2:
        return 'Makes visible all medical data accessible to Prism from every Provider.';
      case 3:
        return 'Allows you to see the Client\'s other Providers\' names and profiles.';
      default:
        return '';
    }
  };

  return (
    <div className="row-flex column-gap-8 justify-center">
      {permissions.map((permission, permissionIndex) => (
        <div style={{ position: 'relative' }} key={permission.VisualName + "_" + permissionIndex + "_" + rowIndex}>
          <div
            onMouseEnter={() => selectPermission(rowIndex, permissionIndex)}
            onMouseLeave={() => selectPermission(null)}
          >
            <Icon
              classNames={`permission-icon-size permission_icon ${classNameTriskeleParser(
                permission.VisualName,
                permission.VisualType,
                'Icon'
              )}`}
            />
          </div>
          {selectedPermission
            && selectedPermission.permissionIndex === permissionIndex
            && selectedPermission.rowIndex === rowIndex && (
              <div
                className="dialog_items position-top-35 "  
              >
                <label style={{ marginBottom: 0 }}>
                  {renderText(selectedPermission.permissionIndex + 1)}
                </label>
              </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PermissionsCard;
